import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';
import { LegalAssociationsAdvocatingItemModel } from '../types';

const legalAssociationsAdvocatingItemValidator: ValidateJSModel<LegalAssociationsAdvocatingItemModel> = {
  Dates: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options?.applicantBirthdate), latest: DEFAULT_LATEST },
  }),

  Reasons: { presence: true, hasValue: true },
};

export default legalAssociationsAdvocatingItemValidator;
